import React from "react";
import DropdownOption from "./DropdownOption";

const DropdownList = ({ options, onOptionClick, highlightedIndex, optionRefs, onDelete }) => {
  return (
    <ul className="dropdown-list">
      {options.map((option, index) => (
        <DropdownOption
          key={option.id}
          option={option}
          index={index}
          onClick={() => onOptionClick(option)}
          highlighted={highlightedIndex === index}
          optionRefs={optionRefs}
          onDelete={onDelete}
        />
      ))}
    </ul>
  );
};

export default DropdownList;
